import 'dayjs/locale/en';
import 'dayjs/locale/fr';

import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(customParseFormat);
dayjs.extend(localizedFormat); // Enables locale-aware format tokens: L, LL, LT, ll, etc.
dayjs.extend(relativeTime); // Enables .fromNow() and .toNow() for relative time strings
